module.exports = __webpack_public_path__ + "static/media/info.f5f68b92.md";